import baseRequest from './baseRequest';

const baseUrl = '/api/auto';

export const updateAutoLoanSubType = async (
  loanId: string,
  subTypeParams: AutoService.AutoLoanSubType,
): Promise<void> => {
  await baseRequest.put(`${baseUrl}/loans/${loanId}/sub-type`, subTypeParams);
};

export const getConfig = async (): Promise<AutoService.LoginConfig> => {
  return (await baseRequest.get(`${baseUrl}/config/login-app`)).data;
};
